import { render, staticRenderFns } from "./addPersonInCharge.vue?vue&type=template&id=66e9c2c9&scoped=true&"
import script from "./addPersonInCharge.vue?vue&type=script&lang=js&"
export * from "./addPersonInCharge.vue?vue&type=script&lang=js&"
import style0 from "./addPersonInCharge.vue?vue&type=style&index=0&id=66e9c2c9&lang=stylus&scoped=true&"
import style1 from "./addPersonInCharge.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e9c2c9",
  null
  
)

export default component.exports